import React, { memo, useCallback, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { Empty, Modal, Select } from "antd";
import { Menu, MenuItem } from "@mui/material";
import { useVendorProvider } from "../../../../Providers/Client/Vendor";
import { useJobProvider } from "../../../../Providers/Client/Jobs";
import Swal from "sweetalert2";
import CustomTable from "../../../../Components/Table";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { userPermissions } from "../../../../Utils/constants";

const headCells = [
  { label: "Sr", disablePadding: true },
  { label: "Name" },
  { label: "Date" },
  { label: "Status" },
  { label: "" },
];

export default function JobsTable2({ setActive, projectId, setJobId, setPostJob, setJobType }) {
  const [currentJob, setCurrentJob] = useState(null);
  const [anchor, setAnchor] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const { vendors, fetchVendors } = useVendorProvider();
  const { jobs, fetchJobsByProject, assignVendorToJob } = useJobProvider();
  const permissions = useSelector((state) => state.user.permissions);
  useEffect(() => {
    fetchVendors();
    fetchJobsByProject(projectId);
  }, [projectId]);

  const navigate = useNavigate()

  const location = useLocation()

  const CustomRow = useCallback(
    memo(({ row, index }) => {
      return (
        <TableRow
          hover
          tabIndex={-1}
          key={row?.job?.id}
          className="cursor-pointer"
        >
          <TableCell onClick={() => {
            navigate(`/dashboard/jobs/${row?.job?.id}`, { state: { from: location } })
          }} component="th" scope="row" padding="none">
            {index + 1}
          </TableCell>
          <TableCell onClick={() => {
            navigate(`/dashboard/jobs/${row?.job?.id}`, { state: { from: location } })
          }} align="left">{row?.job?.name}</TableCell>
          <TableCell onClick={() => {
            navigate(`/dashboard/jobs/${row?.job?.id}`, { state: { from: location } })
          }} align="left">{row?.job?.start_date}</TableCell>
          <TableCell onClick={() => {
            navigate(`/dashboard/jobs/${row?.job?.id}`, { state: { from: location } })
          }} align="left">
            <span
              className="px-2 py-1 text-sm rounded-md"
              style={{
                backgroundColor:
                  row?.job?.status === "ONGOING"
                    ? "#2196F333"
                    : "#13958833",
                color:
                  row?.job?.status === "ONGOING"
                    ? "#2196F3"
                    : "#139588",
              }}
            >
              {row?.job?.status}
            </span>
          </TableCell>
          <TableCell>
            <button
              onClick={(e) => {
                setCurrentJob({
                  id: row?.job?.id,
                  vendorExists: row?.vendor_id ? true : false,
                });
                setAnchor(e.currentTarget);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                />
              </svg>
            </button>
          </TableCell>
        </TableRow >
      )
    }),
    []
  );

  const ExtraComponents = () => {
    return (
      <Menu
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
      >
        {permissions?.includes(`admin-client`) ||
          permissions?.includes(userPermissions.job.vendorAction) ? (
          <MenuItem
            onClick={() => {
              if (currentJob.vendorExists) Swal.fire("Vendor already assigned");
              else setModalOpen(true);
              setAnchor(null);
            }}
          >
            Assign to Vendor
          </MenuItem>
        ) : null}
        <MenuItem
          onClick={() => {
            setJobId(currentJob?.id);
          }}
        >
          View Details
        </MenuItem>
        {permissions?.includes(`admin-client`) ||
          permissions?.includes(userPermissions.job.edit) ? (
          <MenuItem
            onClick={() => {
              setJobId(currentJob?.id);
              setPostJob(true);
              setJobType("Hourly/ Contract");
            }}
          >
            Edit Job
          </MenuItem>
        ) : null}
      </Menu>
    );
  };

  const CustomEmpty = () => {
    return (
      <div className="py-4">
        <Empty />

        {jobs[projectId] ? (
          <div className="flex flex-col text-center text-green-700">
            <span>No Job exist for this project</span>
          </div>
        ) : (
          <div className="flex justify-center text-green-700">
            <span>Please select a project to list the jobs</span>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="mt-[30px] grow">
      <div className="w-[100%]">
        <CustomTable
          title="JobsTable"
          headCells={headCells}
          rows={jobs[projectId] ?? []}
          CustomRow={CustomRow}
          showToolbar={false}
          CustomEmpty={CustomEmpty}
          showHeaderOnEmpty
          ExtraComponents={ExtraComponents}
        />
      </div>
      <Modal
        open={modalOpen}
        title="Assign Vendor"
        onOk={async () => {
          assignVendorToJob({
            job_id: currentJob.id,
            vendor_id: selectedVendor,
          }).then(() => {
            setModalOpen(false);
            setAnchor(null);
            setSelectedVendor(null);
          });
        }}
        onCancel={() => {
          setSelectedVendor(null);
          setModalOpen(false);
          setAnchor(null);
        }}
        okButtonProps={{
          className: "bg-[#1677ff]",
          disabled: selectedVendor === null,
        }}
      >
        <Select
          className="w-full mt-4 mb-2"
          placeholder="Select Vendor"
          value={selectedVendor}
          onChange={(value) => {
            if (value === -1) {
              setActive("vendors");
            } else {
              setSelectedVendor(value);
            }
          }}
          options={vendors
            .filter(
              (vendor) =>
                vendor.status === "Current" || vendor.status === "Requested"
            )
            .map((vendor) => ({
              value:
                vendor.status === "Current" ? vendor.id : vendor.vendorId,
              label: `${vendor.companyName}`.trim(),
            }))
            .concat([{ value: -1, label: "Add New Vendor" }])}
        />
      </Modal>
    </div>
  );
}
